import { Td } from '../styled';
import { Table } from './Table';
import { Bones as BonesCore, Box } from '@simplywallst/ui-core';

const BonesText = ({ width }: { width: string }) => (
  <Box>
    <BonesCore maxWidth={width} minHeight="auto" style={{ height: '14px' }} />
  </Box>
);

const BonesBadge = () => (
  <Box width="75%" style={{ marginLeft: 'auto', marginBlock: '-2px' }}>
    <BonesCore borderRadius="x20space" style={{ height: '22px' }} />
  </Box>
);

export const Skeleton = () => (
  <Table isBusy>
    <Table.HeadFake />
    <Table.Head />
    <Table.Body>
      <tr>
        <Td>
          <BonesText width="90%" />
        </Td>
        <Td>
          <BonesBadge />
        </Td>
      </tr>
      <tr>
        <Td>
          <BonesText width="80%" />
        </Td>
        <Td>
          <BonesBadge />
        </Td>
      </tr>
      <tr>
        <Td>
          <BonesText width="50%" />
        </Td>
        <Td>
          <BonesBadge />
        </Td>
      </tr>
      <tr>
        <Td>
          <BonesText width="70%" />
        </Td>
        <Td>
          <BonesBadge />
        </Td>
      </tr>
      <tr>
        <Td>
          <BonesText width="80%" />
        </Td>
        <Td>
          <BonesBadge />
        </Td>
      </tr>
    </Table.Body>
  </Table>
);
